// Rilevamento Safari (desktop/iOS, esclude Chrome iOS)
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      // Scroll "Safari-safe": disattiva temporaneamente snap/smooth e ripristina a fine frame
      safariScrollTo(el, left) {
        if (!el) return;
        const prevSnap = el.style.scrollSnapType;
        const prevWebkitSnap = el.style.webkitScrollSnapType;
        const prevBehavior = el.style.scrollBehavior;
        const prevOverflow = el.style.overflow;

        el.style.scrollSnapType = 'none';
        el.style.webkitScrollSnapType = 'none';
        el.style.scrollBehavior = 'auto';
        el.style.overflow = 'hidden';

        el.scrollTo({ left });

        requestAnimationFrame(() => {
          el.style.scrollSnapType = prevSnap || '';
          el.style.webkitScrollSnapType = prevWebkitSnap || '';
          el.style.scrollBehavior = prevBehavior || '';
          el.style.overflow = prevOverflow || '';
        });
      }

      onSlideChanged(event) {
        const mediaVideo = this.querySelector(`#Slide-${event.detail.currentElement.dataset.mediaId}.is_video`);

        this.querySelectorAll('.product__media-item').forEach((element) => {
          element.classList.remove('is-active');
        });

        if (mediaVideo) {
          this.playActiveMedia(mediaVideo);
          mediaVideo.classList.add('is-active');
        } else {
          const dm = this.querySelector('.deferred-media');
          if (dm) dm.removeAttribute('loaded');
        }

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        const activeMediaVideo = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"].is_video`);

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (!activeMediaVideo) {
          const dm = this.querySelector('.deferred-media');
          if (dm) dm.removeAttribute('loaded');
        }

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            const track = activeMedia.parentElement;
            const left = Math.round(activeMedia.offsetLeft);
            if (isSafari) {
              this.safariScrollTo(track, left);
            } else {
              track.scrollTo({ left, behavior: 'smooth' });
            }
          }

          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            if (isSafari) {
              // Nessun smooth su Safari: evita ri-snap/agganci strani tornando alla slide 1
              activeMedia.scrollIntoView();
            } else {
              activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
          }
        });

        if (window.innerWidth >= 990) {
          this.playActiveMedia(activeMedia);
        }

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        const pos = activeThumbnail ? activeThumbnail.dataset.mediaPosition : undefined;
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, pos);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        // Stato ARIA esplicito
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));

        const btn = thumbnail.querySelector('button');
        if (btn) btn.setAttribute('aria-current', 'true');

        const tTrack = this.elements.thumbnails.slider;
        if (!tTrack) return;

        const tLeft = Math.round(thumbnail.offsetLeft);

        if (isSafari) {
          this.safariScrollTo(tTrack, tLeft);
        } else {
          tTrack.scrollTo({ left: tLeft, behavior: 'smooth' });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
